import {
  FrameAnchorType,
  HorizontalPositionAlign,
  Paragraph,
  TextRun,
  VerticalPositionAlign,
} from "docx";
import { generateSectionParagraphs } from "../utils/WordExportUtils";
import {
  bigFontSize,
  blueColour,
  defaultFontBold,
  defaultFontNormal,
  indentationLevel1,
  mediumFontSize,
  orangeColour,
} from "../utils/styling";
export const getCoverPage = (data) => {
  const { groupName, formattedPoAEnd } = data;

  const paragraphs = [
    {
      indentation: indentationLevel1,
      spaceBefore: 900,
      segments: [
        {
          text: "Corporate Interest Restriction calculations",
          font: defaultFontBold,
          size: bigFontSize,
          color: orangeColour,
          break: 5,
        },
      ],
    },
    {
      indentation: indentationLevel1,
      spaceBefore: 200,
      segments: [
        {
          text: groupName,
          font: defaultFontNormal,
          size: mediumFontSize,
        },
        {
          text: "Period of Account ended",
          font: defaultFontNormal,
          size: mediumFontSize,
          break: 1,
        },
        {
          text: formattedPoAEnd,
          font: defaultFontNormal,
          size: mediumFontSize,
          break: 1,
        },
      ],
    },
    {
      indentation: indentationLevel1,
      segments: [
        {
          text: "[This report sets out the key aspects of the CIR calculations for the group, based on the inputs and outputs from the CIR Analyser. It should be reviewed for consistency and accuracy, before being sent to the client alongside the calculations and draft return. There are various sections, identified with blue text, which require consideration / input from the relationship team prior to finalising the report. Please review the document and make amendments as required, removing all sections in blue text (including this paragraph) prior to sending]",
          font: defaultFontNormal,
          color: blueColour,
          break: 5,
        },
      ],
    },
  ];

  const sideRibbon = new Paragraph({
    frame: {
      width: 1500,
      height: 18000,
      anchor: {
        horizontal: FrameAnchorType.PAGE,
        vertical: FrameAnchorType.PAGE,
      },
      alignment: {
        x: HorizontalPositionAlign.LEFT,
        y: VerticalPositionAlign.CENTER,
      },
    },
    shading: {
      fill: "#FD5107",
    },
    children: [new TextRun("")],
  });

  return [sideRibbon, ...generateSectionParagraphs(paragraphs)];
};
